module.exports = __webpack_public_path__ + "static/cli_lyre-d8bfb9262ae14cd7198d4d29777dacb8.jpg";